var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('binds-icon',{staticClass:"binds-icon-image"},[_c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"}}),_c('path',{attrs:{"d":"M0-.25h24v24H0z","fill":"none"}})])])
}]

export { render, staticRenderFns }